import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';

export interface IButtonCardUIProps {
    id?: string;
    buttonState?: string;
    buttonText?: string;
    routeTo?: string;
    onButtonClick?: { (routeTo: string): void };
    handlerPostRoute?: { (): void };
    disable?: boolean;
}

export interface IButtonCardUIState {
}

export default class ButtonCardUI extends Component<IButtonCardUIProps, IButtonCardUIState> {

    static propTypes = {
        id: PropTypes.string,
        buttonState: PropTypes.string,
        buttonText: PropTypes.string.isRequired,
        routeTo: PropTypes.string,
        disable: PropTypes.bool,
        isClickable: PropTypes.bool
    };

    static defaultProps = {
        buttonText: 'Card Heading Text',
        buttonState: 'active'
    };

    constructor(props) {
        super(props);
    }

    isClickable() {
        const { routeTo } = this.props;
        return routeTo !== null && routeTo !== undefined;
    }

    handleClick() {
        const { onButtonClick, routeTo, buttonState, disable, handlerPostRoute } = this.props;

        if (!disable && this.isClickable()) {
            onButtonClick(routeTo);
        }
        handlerPostRoute && handlerPostRoute();
    }

    render() {
        const {
            buttonState,
            buttonText,
            disable,
            routeTo,
            onButtonClick
        } = this.props;

        return (
            <button type="button" disabled={ disable } className="btn btn-primary btn-sm btn-block dr-ui-buttoncard"
                onClick={ () => this.handleClick() }>
                {buttonText}
            </button>
        );
    }
}
